import { DropDownItem, GenerateDropDownItems, SearchByItem } from "@app/shared/classes/general";
import { TableColumnDef } from "@app/shared/components/smart-data-grid/data-grid/data-grid.constants";
import { smartSearchType } from "@app/shared/components/smart-search-form/smart-search-form.constant";
import { CountryCodeTranslate } from "@app/shared/pipes/country-code-translate";
import { LocaleDate } from "@app/shared/pipes/locale-date";
import { SubRegion } from "@app/shared/classes/subRegion";
import { CommonFieldLabel, CommonFieldName } from "@app/shared/constants";

export enum AwardFieldName {
  driverName = "driverName",
  terminalId = "terminalId",
  terminalName = "terminalName",
  subRegionName = "subRegionName",
  country = "country",
  awardName = "awardname",
  awardDate = "awardDate",
  created_On = "created_On",
  created_By = "created_By",
  lastModified_On = "lastModified_On",
  lastModified_By = "lastModified_By",

  apexId = "apexId",
  fullName = "fullName",

  rowNum = "rowNum",
  errorMessage = "errorMessage"
};

enum FieldLabel {
  DRIVER_NAME = "ml_143908",
  TERMINAL = "ml_144113",
  TERMINAL_ID = "ml_143909",
  TERMINAL_NAME = "ml_143910",
  SUB_REGION = "ml_143911",
  COUNTRY = "ml_143912",
  AWARD_NAME = "ml_151029",
  AWARD_DATE = "ml_151030",
  CREATED_BY = "ml_143916",
  CREATED_ON = "ml_143917",
  LAST_CHANGED_BY = "ml_143918",
  LAST_CHANGED_ON = "ml_143919",

  DRIVER_APEX_ID = "ml_143930",

  LINE_NUMBER = "ml_143953",
  IMPORT_FAILED_MESSAGE = "ml_143954"
}

const AwardSearchByList: SearchByItem[] = [
  { searchBy: AwardFieldName.apexId, searchByLabel: FieldLabel.DRIVER_APEX_ID },
  { searchBy: AwardFieldName.fullName, searchByLabel: FieldLabel.DRIVER_NAME },
  { searchBy: AwardFieldName.terminalId, searchByLabel: FieldLabel.TERMINAL, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  { searchBy: AwardFieldName.subRegionName, searchByLabel: FieldLabel.SUB_REGION, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  {
    searchBy: AwardFieldName.awardDate, searchByLabel: FieldLabel.AWARD_DATE, searchByType: smartSearchType.dateRangeSelct
  },
  { searchBy: CommonFieldName.lastModified_By, searchByLabel: CommonFieldLabel.LAST_CHANGED_BY },
  { searchBy: CommonFieldName.lastModified_On, searchByLabel: CommonFieldLabel.LAST_CHANGED_ON, searchByType: smartSearchType.dateRangeSelct }
];

export const DataGridColumnDef: TableColumnDef[] = [
  {
    text: FieldLabel.DRIVER_NAME,
    name: AwardFieldName.driverName,
    sort: true,
    sortFieldName: AwardFieldName.fullName
  },
  {
    text: FieldLabel.TERMINAL_ID,
    name: AwardFieldName.terminalId,
    sort: true,
  },
  {
    text: FieldLabel.TERMINAL_NAME,
    name: AwardFieldName.terminalName,
    sort: true
  },
  {
    text: FieldLabel.SUB_REGION,
    name: AwardFieldName.subRegionName,
    sort: true
  },
  {
    text: FieldLabel.COUNTRY,
    name: AwardFieldName.country,
    sort: true,
    pipe: CountryCodeTranslate
  },
  {
    text: FieldLabel.AWARD_NAME,
    name: AwardFieldName.awardName,
    sort: true
  },
  {
    text: FieldLabel.AWARD_DATE,
    name: AwardFieldName.awardDate,
    sort: true,
    pipe: LocaleDate
  },
  {
    text: FieldLabel.LAST_CHANGED_BY,
    name: AwardFieldName.lastModified_By,
    sort: true
  },
  {
    text: FieldLabel.LAST_CHANGED_ON,
    name: AwardFieldName.lastModified_On,
    sort: true,
    pipe: LocaleDate
  }
];

export const GetAwardSearchByList = ([terminals, subRegions]: [DropDownItem[], SubRegion[]]) => {
  var result = AwardSearchByList.slice();
  result[2].searchDropDownValue = terminals;
  result[3].searchDropDownValue = subRegions ? GenerateDropDownItems(subRegions.map(item => item.subRegionName)) : [];
  return result;
}

export const ImportResultDataGridColumnDef: TableColumnDef[] = [
  {
    text: FieldLabel.LINE_NUMBER,
    name: AwardFieldName.rowNum,
    sort: true,
    width: 5
  },
  {
    text: FieldLabel.IMPORT_FAILED_MESSAGE,
    name: AwardFieldName.errorMessage,
    sort: true,
    width: 95
  }]
  ;
